// src/utils/useWhiteLabel.js
import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const DEFAULT_CONFIG = {
  whiteLabel:   false,
  appName:      'EscapOS',
  logoUrl:      null,
  faviconUrl:   null,
  primaryColor: '#7c5cfc',
  accentColor:  '#00d2b4',
  bgColor:      '#0d0d1a',
};

function applyConfig(config) {
  const root = document.documentElement;

  // CSS variables
  if (config.primaryColor) root.style.setProperty('--accent',       config.primaryColor);
  if (config.accentColor)  root.style.setProperty('--teal',         config.accentColor);
  if (config.bgColor)      root.style.setProperty('--bg-base',      config.bgColor);

  // Titre de la page
  if (config.appName) document.title = config.appName;

  // Favicon
  if (config.faviconUrl) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = config.faviconUrl;
  }
}

export function useWhiteLabel() {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/config`)
      .then(r => {
        const cfg = { ...DEFAULT_CONFIG, ...r.data };
        setConfig(cfg);
        applyConfig(cfg);
      })
      .catch(() => {
        // En cas d'erreur, garder la config par défaut
        applyConfig(DEFAULT_CONFIG);
      })
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
}

// Utilitaire pour appliquer manuellement (preview live)
export function previewWhiteLabel(config) {
  applyConfig({ ...DEFAULT_CONFIG, ...config });
}

export function resetWhiteLabel() {
  applyConfig(DEFAULT_CONFIG);
  document.title = 'EscapOS';
}
